module.exports = __webpack_public_path__ + "img/WechatIMG1019.c9a5dcf0.png";